// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const ScheduleMasterSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.blue}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g
        id="Search_Results"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Practice-Badges-Profile"
          transform="translate(-36.000000, -1518.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Schedule-Master" transform="translate(25.000000, 1508.000000)">
            <path
              d="M16.25,11.5 L16.25,10 L15.5,10 L15.5,11.5 L16.25,11.5 Z M24.5,11.5 L24.5,10 L23.75,10 L23.75,11.5 L24.5,11.5 Z M29,15.25 L29,11.5 L24.5,11.5 L24.5,13.75 L23.75,13.75 L23.75,11.5 L16.25,11.5 L16.25,13.75 L15.5,13.75 L15.5,11.5 L11,11.5 L11,15.25 L29,15.25 Z M29,28 L29,16 L11,16 L11,28 L29,28 Z"
              id=""
            />
          </g>
        </g>
      </g>
    </svg>
  </SvgContainer>
);
ScheduleMasterSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default ScheduleMasterSvg;
